/**
 * Chat markdown normalization helpers.
 *
 * @module chat/messages/markdown-normalization
 */

const ORDERED_MARKER_ONLY_PATTERN = /^(\s*)(\d{1,3}[.)])\s*$/;

/**
 * Joins model-emitted ordered-list markers with the following text line.
 *
 * Some models stream numbered prose as:
 *
 * 1.
 * First item text
 *
 * Markdown treats that as an empty list item followed by a paragraph. For chat
 * display, keep the user's expected numbered-list shape by rewriting it to:
 *
 * 1. First item text
 */
export function normalizeSplitOrderedListMarkers(markdown: string): string {
  const lines = markdown.split("\n");
  const normalized: string[] = [];

  for (let index = 0; index < lines.length; index += 1) {
    const currentLine = lines[index] ?? "";
    const markerMatch = currentLine.match(ORDERED_MARKER_ONLY_PATTERN);
    let nextTextIndex = index + 1;
    while (
      nextTextIndex < lines.length &&
      (lines[nextTextIndex] ?? "").trim().length === 0
    ) {
      nextTextIndex += 1;
    }
    const nextLine = lines[nextTextIndex];

    if (
      markerMatch &&
      nextLine !== undefined &&
      !ORDERED_MARKER_ONLY_PATTERN.test(nextLine)
    ) {
      const [, indent, marker] = markerMatch;
      normalized.push(`${indent}${marker} ${nextLine.trimStart()}`);
      index = nextTextIndex;
      continue;
    }

    normalized.push(currentLine);
  }

  return normalized.join("\n");
}
